import { Box } from "@mui/material";
import NSSFContributionMethodsForm from "./form";
import { HRService } from "../../../../config";
import { NSSFContributionMethodsColumns } from "../../../../data/Columns/hrmanagement";
import DynamicTable from "../../../../data/DynamicTable/dynamicTable";
import { NSSFContributionMethods } from "../../../../data/Columns/Queries/HRmanagement/leavemanagement";

const base_url = HRService.uri;

const actions = {
  entity: "NSSF Contribution Methods",
  isSubRight: true,
  edit: {
    key: "EDIT",
    button_name: "Edit",
    Show_Button: true,
    permission: "EditPermission",
  },
  add: {
    key: "ADD",
    button_name: "Add",
    Show_Button: true,
    permission: "CreatePermission",
  },
  activateDeactivate: {
    key: "ACTIVATEDEACTIVATE",
    button_name: "Deactivate",
    Show_Button: true,
    permission: "ActivatePermission",
  },
  AssignTask: {
    key: "ASSIGN_TASK",
    button_name: "Assign Task",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  markTask: {
    key: "MARK_TASK_DONE",
    button_name: "Mark Task Done",
    Show_Button: false,
    permission: "hasNoPermission",
    roleGroupId: [1, 2, 3, 4],
  },
  showStatus: true,
};

function NSSFContributionMethodsTable() { // Now no redeclaration conflict
  return (
    <Box m="2px">
      <DynamicTable
        title="NSSF Contribution Methods"
        subtitle="View all NSSF contribution methods, create and edit"
        columns={NSSFContributionMethodsColumns} // Fixed: Import + plural
        FormComponent={NSSFContributionMethodsForm} // Fixed: Matches import
        actions={actions}
        query={NSSFContributionMethods}
        base_url={base_url}
      />
    </Box>
  );
}

export default NSSFContributionMethodsTable;